import React from 'react';
import cx from 'classnames';
import T from 'prop-types';
import styles from './dots.css';

const Dot = ({
  color, active, index, noTransition,
}) => (
  <div
    style={{
      borderColor: color,
    }}
    className={cx(
      active ? styles.dotActive : styles.dot,
      noTransition && styles.noTransition,
    )}
  >
    <span className={styles.hidden}>{`Слайд номер ${index + 1}`}</span>
  </div>
);

Dot.defaultProps = {
  noTransition: false,
};

Dot.propTypes = {
  color: T.string.isRequired,
  active: T.bool.isRequired,
  index: T.number.isRequired,
  noTransition: T.bool,
};

const Dots = ({
  color, activeIndex, quantity, noTransition, className,
}) => (
  <div className={cx(styles.dots, className)}>
    {Array(quantity)
      .fill('')
      .map((dot, i) => (
        <Dot
          key={i}
          color={color}
          active={activeIndex === i}
          index={i}
          noTransition={noTransition}
        />
      ))}
  </div>
);

Dots.defaultProps = {
  className: null,
  noTransition: false,
};

Dots.propTypes = {
  color: T.string.isRequired,
  activeIndex: T.number.isRequired,
  quantity: T.number.isRequired,
  noTransition: T.bool,
  className: T.string,
};

export default Dots;



// WEBPACK FOOTER //
// ./src/components/modules/Dots/Dots.js